import { CheckCircle2, Mail, Building2 } from 'lucide-react';

const SuccessStep = ({ onClose, onViewDashboard }) => (
  <div className="flex flex-col items-center gap-5 w-full py-2">
    <div className="flex items-center justify-center w-14 h-14 rounded-full bg-green-500/10">
      <CheckCircle2 className="w-8 h-8 text-green-500" />
    </div>
    <div className="text-center pb-4 border-b border-gray-700">
      <h2 className="text-2xl font-semibold text-white">You&apos;re all set! 🎉</h2>
      <p className="mt-2 text-sm text-gray-400 max-w-xs mx-auto">
        Your permit application has been successfully submitted to the city.
      </p>
    </div>
    <div className="w-full space-y-3">
      <div className="flex items-start gap-3 rounded-lg border border-gray-700 bg-black/30 p-3">
        <Mail className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-medium text-white">Expect a City email within the  24 hours</p>
          <p className="text-xs text-gray-400 mt-0.5">
            The City will contact you regarding your permit status and any additional fees that may apply to your
            project.
          </p>
        </div>
      </div>
      {/* <div className="flex items-start gap-3 rounded-lg border border-gray-700 bg-black/30 p-3">
        <Building2 className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-medium text-white">Check your inbox from us shortly</p>
          <p className="text-xs text-gray-400 mt-0.5">
            We&apos;re sending you an email with your City portal login credentials so you can check the live status of
            your application anytime.
          </p>
        </div>
      </div> */}
    </div>
    <div className="w-full space-y-2 pt-1">
      <button
        onClick={onClose}
        className="w-full border border-gray-700 hover:border-gray-500 text-white py-3 rounded-lg transition text-sm"
      >
        Done
      </button>
      <button
        onClick={onViewDashboard}
        className="w-full bg-[#7B7B7B] hover:bg-gray-500 text-white py-3 rounded-lg transition text-sm"
      >
        View Project Dashboard
      </button>

    </div>
  </div>
);

export default SuccessStep;
